<template>
    <HomeLayout title="Fair und günstig mieten">
        <Section
            hero-background
            fullscreen
            class="flex flex-row items-center justify-center"
        >
            <Container>
                <div
                    class="flex flex-col justify-center space-y-20 sm:flex-row sm:space-x-20 sm:space-y-0"
                >
                    <div class="w-full mt-12 sm:w-1/3 sm:mt-0">
                        <SearchBar />
                    </div>

                    <div
                        class="flex items-center justify-center w-full sm:w-1/2"
                    >
                        <img src="/images/car.png" alt="Rotes Auto" />
                    </div>
                </div>
            </Container>
        </Section>

        <Section padding-bottom id="about-us">
            <Container>
                <SectionHeadline>Über uns</SectionHeadline>

                <div
                    class="flex flex-col items-center space-y-20 sm:flex-row sm:space-x-14 sm:space-y-0"
                >
                    <div class="flex justify-end sm:w-1/2">
                        <img
                            src="/images/about_us.png"
                            alt="Einige Autoausschnitte"
                            class="max-h-[400px]"
                        />
                    </div>

                    <div class="max-w-sm sm:w-1/2">
                        <div class="mb-4 text-2xl font-bold text-primary-text">
                            Schnell, günstig und bequem Fahrzeuge mieten
                        </div>
                        <div class="mb-6 text-lg text-primary-text">
                            Wir sind davon überzeugt, dass das Mieten von
                            Fahrzeugen nicht kompliziert und auch nicht teuer
                            sein muss. In unserer Fahrzeugflotte bieten wir
                            Pkws, Transporter und Oldtimer zu fairen Preisen an.
                        </div>

                        <!-- <div>
                            <Link>
                                <StyledButton background-primary>
                                    Kontaktieren Sie uns!
                                </StyledButton>
                            </Link>
                        </div> -->
                    </div>
                </div>
            </Container>
        </Section>

        <Section padding-bottom id="faq">
            <Container>
                <SectionHeadline>FAQ</SectionHeadline>

                <div
                    class="flex flex-col gap-y-6 max-w-[1200px] mx-auto w-full px-4 sm:px-6 lg:px-8"
                >
                    <Question
                        should-be-open
                        question="Wie ist das Mindestalter zum Mieten eines Fahrzeugs?"
                        answer="Das Mindestalter zum Mieten eines Fahrzeugs beträgt 23 Jahre."
                    />

                    <Question
                        question="Wie hoch ist die Selbstbeteiligung?"
                        answer="Die Selbstbeteiligung beträgt 1.500 Euro."
                    />
                </div>
            </Container>
        </Section>
    </HomeLayout>
</template>

<script>
import HomeLayout from "@/Layouts/HomeLayout.vue";
import SearchBar from "@/Components/SearchBar.vue";
import Section from "@/Components/Section.vue";
import SectionHeadline from "@/Components/SectionHeadline.vue";
import Container from "@/Components/Container.vue";
import { Link } from "@inertiajs/inertia-vue3";
import StyledButton from "@/Components/StyledButton.vue";
import Question from "@/Components/Question.vue";

export default {
    components: {
        HomeLayout,
        Section,
        SectionHeadline,
        Container,
        SearchBar,
        StyledButton,
        Link,
        Question,
    },
};
</script>
